import { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap"
import { ArrowRightCircle } from "react-bootstrap-icons"
import bannerImg from '../assets/img/banner-img.png'
import 'animate.css'
import TrackVisibility from "react-on-screen";
import { isVisible } from "@testing-library/user-event/dist/utils";

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Web Developer", "Web Designer", "Software Engineer"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 1800;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => { clearInterval(ticker)};
    }, [text])

    const redirectToLinkedIn = () => {
        window.location.href = 'https://www.linkedin.com/in/tang-zong-hao';
    };

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length -1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if(isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if(!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if(isDeleting && updatedText==='') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }

    return (
        <section className="banner" id='home'>
            <Container>
                <Row className='align-items-center'>
                    <Col xs={12} md={6} xl ={7} style={{ color: 'black' }}>
                        <TrackVisibility>
                        {({isVisible}) =>
                        <div className={isVisible ? "animate__animated animate__fadeIn" : ""} >
                            <span className="tagline">Welcome to my Portfolio</span>
                            <h1>{'Hi! Zong Hao here! '}<span className="wrap">{text}</span></h1>
                            <p>I am a Penultimate Computer Science Undergrad in NUS, with a keen interest in Parallel Computing & Distributed Systems, Computer Networking and Artificial Intelligence! Scroll down to see more about the things I've worked on and connect with me today to learn more!</p>
                            <button onClick={() => redirectToLinkedIn()}>Let's connect! <ArrowRightCircle size={25} /></button>
                        </div>}
                        </TrackVisibility>
                    </Col>
                    <Col Col xs={12} md={6} xl ={5}>
                    <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__pulse" : ""}>
                        <img src={bannerImg} alt="Header img" className="bannerImg"/>
                    </div>}
                    </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>

    )
}